import React from 'react';
import Link from "./Application/Link";
import appUserRoutes from "../appUserRoutes";
import {Alert} from "reactstrap";
import {useTranslation} from "react-i18next";

const PlanFeatureDisabled = () => {
  const { t } = useTranslation('plan_feature_disabled');

  return (
    <Alert color={'info'} className="d-flex align-items-center">
      <i className="fas fa-info-circle fa-2x mr-3" />
      <span>{t('text')} <Link to={appUserRoutes.choosePlan}>{t('link')}</Link>.</span>
    </Alert>
  );
};

export default PlanFeatureDisabled;
